



































import globals from "@/general/store/modules/globals";
import { Prop, Component, Vue } from "vue-property-decorator";

import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Swiper } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { SwiperOptions, Swiper as SwipeClass, Navigation } from "swiper";
SwipeClass.use([Navigation]);

@Component({
  components: {
    IconBase,
    IconArrowLeft,
    IconArrowRight,
    Swiper
  }
})
export default class Carousel2 extends Vue {
  @Prop({ type: Object, default: () => ({}) }) mergeOptions!: object;

  initOptions: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1.3,
    spaceBetween: 24,
    loop: true,
    centeredSlides: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".c-carousel__pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".c-carousel__next",
      prevEl: ".c-carousel__prev"
    },
    breakpoints: {
      1024: {
        slidesPerView: 3
      }
    },
    lazy: true,
  };

  // get swiper() {
  //   return this.$refs.carousel.$swiper;
  // }

  get swiperOption(): SwiperOptions {
    if (!this.mergeOptions) return this.initOptions;
    return { ...this.initOptions, ...this.mergeOptions };
  }

  get isSp(): boolean {
    return globals.isLargeBreakpointWidthOfSp;
  }

  created() {
    this.initOptions.centeredSlides = this.isSp ? true : false;
  }
}
